import LocalizedStrings from "react-localization";

const Empty = ({ fill = "#A9A9A9", width = "100%", height = "100%" }) => (
  <div
    style={{
      width,
      height,
      textAlign: "center",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    }}
  >
    <div style={{ width, height, maxHeight: "100px", display: "inline-grid" }}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet"
        fill={fill}
      >
        <g
          transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
          stroke="none"
        >
          <path d="M960 1575 l0 -135 40 0 40 0 0 135 0 135 -40 0 -40 0 0 -135z" />
          <path
            d="M575 1654 c-11 -8 -26 -19 -34 -23 -10 -6 1 -31 49 -107 79 -125 83
-129 106 -115 50 28 51 23 -25 145 -40 64 -74 116 -75 116 0 0 -10 -8 -21 -16z"
          />
          <path
            d="M1350 1554 c-40 -63 -71 -116 -69 -118 22 -15 59 -36 64 -36 6 0 134
195 142 215 2 7 -11 22 -30 33 l-35 20 -72 -114z"
          />
          <path
            d="M231 915 c-113 -102 -210 -185 -218 -185 -10 0 -13 -60 -13 -317 0
-298 1 -320 20 -350 40 -67 -15 -63 982 -63 878 0 904 1 935 20 62 37 63 46
63 395 0 255 -3 315 -13 315 -8 0 -105 83 -218 185 l-204 184 -565 0 -565 0
-204 -184z m1454 -37 l159 -143 -257 -3 -257 -2 0 -46 c0 -60 -31 -118 -82
-151 l-42 -28 -206 0 -206 0 -42 28 c-51 33 -82 91 -82 151 l0 46 -257 2 -257
3 159 143 159 142 526 0 526 0 159 -142z m-1083 -285 c22 -59 77 -120 133
-148 36 -18 62 -20 265 -20 203 0 229 2 265 20 56 28 111 89 133 148 l20 52
248 0 249 0 3 -264 c2 -235 1 -266 -14 -283 -16 -17 -54 -18 -902 -18 -810 0
-887 1 -904 17 -17 15 -18 37 -18 278 0 144 3 265 7 269 4 3 117 5 251 4 l244
-3 20 -52z"
          />
        </g>
      </svg>
    </div>
    <p style={{ marginTop: "10px", color: "#718096" }}>{strings.noData}</p>
  </div>
);

const strings = new LocalizedStrings({
  es: {
    noData: "Sin datos",
  },
});

export default Empty;
